module.exports = __webpack_public_path__ + "static/img/back-5-1.ea9c7a1b.png";